import auth0 from 'auth0-js';
import { createActions } from 'redux-actions';
import { call, put, select } from 'redux-saga/effects';
import { logoutAuth0 } from '../../../../remote-apis';
import { auth0ConfigSelector } from '../../configuration/selectors';
import clearSessionActions from './clearSession';

const actions = createActions({
  SESSION: {
    LOGOUT: (invitationToken) => ({ invitationToken })
  }
})

export function* logout(action) {
  const auth0Config = yield select(auth0ConfigSelector);

  // if trying to log out, but can't get auth0 config then bail out with a
  // forced logout so login can continue.
  if (!auth0Config) {
    return yield put(clearSessionActions.session.clearSession());
  }

  const webAuth = new auth0.WebAuth({
    clientID: auth0Config.clientId,
    domain: auth0Config.domain
  });

  const { invitationToken } = action.payload;

  yield call(logoutAuth0, invitationToken, webAuth, auth0Config.realm);
}

const configuration = {
  name: 'logout',
  action: actions,
  sagas: logout,
  reducers: {
    reducer: (state, action) => ({
      ...state,
      isLoggingIn: false,
      isLoggingOut: true
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/session/configurations/logout.js